/**
 * collectStore
 */
import Vue from 'vue';
import * as types from '../mutation-types';
import * as urls from '../../config/urls';
import * as helpers from '../../utils/helpers';
import auth from '../../utils/auth';


const LIKELIST = 'LIKELIST'; // 点赞
const COLLECTLIST = 'COLLECTLIST'; // 收藏


const UPDATE_LIKE_EXTRA_INFO = 'UPDATE_LIKE_EXTRA_INFO'; // 最新总数
const UPDATE_COLLECT_EXTRA_INFO = 'UPDATE_COLLECT_EXTRA_INFO'; // 最新总数
export default {
    namespaced: true,

    state: {

        collectList: [],
        livelist: [],
        collectLoading: false,
        collectExtra: 0,
        likeExtra: 0,
        collectQueries: {
            pagination: 1,
            pageSize: 12,
        },
        likeQueries: {
            pagination: 1,
            pageSize: 12,
        },
    },

    mutations: {
        [types.UPDATE_LIST](state, {
            subject,
            list,
        }) {
            state[`${subject}List`] = list;
        },
        [types.UPDATE_LOADING_STATUS](state, {
            subject,
            isLoading,
        }) {
            state[`${subject}Loading`] = isLoading;
        },
        [types.UPDATE_EXTRA_INFO](state, { subject, extra }) {
            state[`${subject}Extra`] = extra;
        },
        // 最热
        [LIKELIST](state, { list }) {
            state.livelist = list;
        },
        [COLLECTLIST](state, { list }) {
            state.collectList = list;
        },

        [UPDATE_LIKE_EXTRA_INFO](state, { subject, extra }) {
            state[`${subject}Extra`] = extra;
        },
        [UPDATE_COLLECT_EXTRA_INFO](state, { subject, extra }) {
            state[`${subject}Extra`] = extra;
        },

    },

    actions: {
        // 推荐列表
        getLikeList({ commit }, queries = {}) {
            const subject = 'like';
            const {
                pageSize,
                pagination,
            } = queries;

            return new Promise((resolve, reject) => {
                Vue.http.get(urls.GET_LIKE_LIST, {
                    params: {
                        page: pageSize,
                        size: pagination,
                        ...otherQueries,
                    },
                }).then((response) => {
                    const list = response.data.data.list || {};
                    commit(LIKELIST, { list });
                    const { total } = response.data.data;

                    commit(UPDATE_LIKE_EXTRA_INFO, { subject, extra: total });
                    resolve(response);
                }).catch((error) => {
                    reject(error);
                });
            });
        },

        //  获取收藏列表
        getCollectList({ commit }, queries = {}) {
            const subject = 'collect';
            const {
                pageSize,
                pagination,
                ...otherQueries
            } = queries;
            const userId = auth.getUserInfo().user_id;
            return new Promise((resolve, reject) => {
                const url = urls.GET_COLLECT_LIST;
                Vue.http.get(url, {
                    params: {
                        pageNumber: pageSize,
                        offset: (pagination - 1) * pageSize,
                        publish: 1,
                        userId,
                        ...otherQueries
                    },
                }).then((response) => {
                    const list = response.data.row || {};
                    commit(COLLECTLIST, { list });
                    const { total } = response.data;

                    commit(UPDATE_COLLECT_EXTRA_INFO, { subject, extra: total });

                    resolve(response);
                }).catch((error) => {
                    reject(error);
                });
            });
        },

        // likeList: 更新
        likeList({ dispatch, state }, formData = {}) {
            const subject = 'like';
            const Subject = subject.replace(/^\w/, _ => _.toUpperCase());
            const { status } = formData;
            const userId = auth.getUserInfo().user_id;
            const data = helpers.pick(formData, [
                'userId',
                'mediaId',
            ]);
            data.like = status;
            data.userId = userId;
            return new Promise((resolve, reject) => {
                const url = `${urls.GET_LIKE_LIST}&userId=${userId}&mediaId=${data.mediaId}&like=${data.like}`;

                Vue.http.post(url, {}).then((response) => {
                    // dispatch(`get${Subject}List`, state[`${subject}Queries`]);

                    resolve(response);
                }).catch((error) => {
                    reject(error);
                });
            });
        },
        // collectLIst: 更新
        collectList({ dispatch, state }, formData = {}) {
            const subject = 'collect';
            const Subject = subject.replace(/^\w/, _ => _.toUpperCase());
            const userId = auth.getUserInfo().user_id;
            const { status } = formData;
            const data = helpers.pick(formData, [
                'mediaId',
            ]);
            data.collection = status;
            data.userId = userId;
            return new Promise((resolve, reject) => {
                const url = `${urls.UPDATA_COLLECT_LIST}&userId=${userId}&mediaId=${data.mediaId}&collection=${data.collection}`;

                Vue.http.post(url, {}).then((response) => {
                    dispatch(`get${Subject}List`, state[`${subject}Queries`]);

                    resolve(response);
                }).catch((error) => {
                    reject(error);
                });
            });
        },
        // 点赞
        LikeList({ dispatch, state }, formData = {}) {
            const subject = 'collect';
            const Subject = subject.replace(/^\w/, _ => _.toUpperCase());


            const data = helpers.pick(formData, [
                'commentUser',
                'mediaId',
            ]);

            return new Promise((resolve, reject) => {
                const url = urls.UPDATA_LIKE_LIST;

                Vue.http.post(url, data).then((response) => {
                    dispatch(`get${Subject}List`, state[`${subject}Queries`]);
                    resolve(response);
                }).catch((error) => {
                    reject(error);
                });
            });
        },

    },
};